import { Form } from "react-bootstrap";

const SelectDatenSet = (props) => {
  const { label, value, disabled, onChange, dataSet } = props || {};

  let konditionenSet = Array.isArray(dataSet)
    ? [...dataSet]
    : [value];
  konditionenSet.sort();
  if (konditionenSet.length < 2) return <div></div>;

  const options = konditionenSet.map(id => {
    return (
      <option key={`set${id}`} value={id}>{id.charAt(0).toUpperCase() + id.slice(1)}</option>
    );
  });

  return <div className="d-flex align-items-center gap-1 mb-one">
    <Form.Label className="m-0">{label ? label : "Auswahl der Daten"}</Form.Label>
    <Form.Select
      disabled={disabled}
      name="datenset"
      aria-label={label ? label : "Auswahl der Daten"}
      className="text-capitalize w-auto"
      onChange={onChange}
      value={value}
    >
      {options}
    </Form.Select>
  </div>;

};
export default SelectDatenSet;
